// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"expand-vertical"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 2.5L5 2.5M19 21.5H5M15.5 9L12 5.5L8.50001 9M8.50001 15L12 18.5L15.5 15M12 17.25L12 6.75","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ExpandVerticalIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'expand-vertical',
    ref,
    icon: element,
  },
));

ExpandVerticalIcon.displayName = 'ExpandVerticalIcon';

export default ExpandVerticalIcon;
